<template>
  <div>
    <div class="mb-2 text-info font-weight-bold">
      <i class="fa fa-info-circle mr-1"></i>
      {{ $t('class-attendance-report-for-admin.absent_students_today') }}
    </div>
    <Table :columns="columns" :data="resources" size="small" max-height="700">
      <template slot-scope="{ row }" slot="card_number">
        {{ row.card_number }}
      </template>
      <template slot-scope="{ row }" slot="student_name">
        {{ row.student_name }}
      </template>
      <template slot-scope="{ row }" slot="gender">
        {{ row.gender }}
      </template>
      <template slot-scope="{ row }" slot="father_name">
        {{ row.father_name }}
      </template>
      <template slot-scope="{ row }" slot="father_phone">
        {{ row.father_phone }}
      </template>
      <template slot-scope="{ row }" slot="mother_name">
        {{ row.mother_name }}
      </template>
      <template slot-scope="{ row }" slot="mother_phone">
        {{ row.mother_phone }}
      </template>
      <template slot-scope="{ row }" slot="absent_status">
            <span
              :class="[
                'badge',
                row.absent_status === 'វត្តមាន'
                  ? 'badge-success'
                  : row.absent_status === 'អវត្តមាន'
                  ? 'badge-danger'
                  : row.absent_status === 'សុំច្បាប់'
                  ? 'badge-info'
                  :''
              ]"
            >
              {{ row.absent_status }}
            </span>
          </template>
      <template slot-scope="{ row }" slot="action">
        <a
          href="#"
          title="edit"
          class="text-primary mr-2"
          @click.prevent="edit(row)"
        >
          <i class="fas fa-edit"></i>
        </a>
      </template>
    </Table>
    <a-modal
      v-model="visible"
      :centered="true"
      :title="
        (edit_data && edit_data.card_number ? edit_data.card_number : '') +
          ' | ' +
          (edit_data && edit_data.student_name ? edit_data.student_name : '')
      "
      :footer="null"
      @cancel="handleCancel"
    >
      <FormAction @cancel="handleCancel" />
    </a-modal>
  </div>
</template>
<script>
import { mapState } from 'vuex'
import FormAction from './form.vue'
export default {
  name: 'table-expand',
  props: {
    records: Array
  },
  components: {
    FormAction
  },
  data() {
    return {
      visible: false
    }
  },
  computed: {
    ...mapState('classAttendanceReport', ['formViewModel', 'edit_data']),
    resources() {
      return this.records
    },
    columns() {
      return [
        {
          title: this.$t('actions'),
          slot: 'action',
          fixed: 'left',
          align: 'center',
          width: 100
        },
        {
          title: this.$t('numberic'),
          key: 'index',
          width: 80,
          align: 'center',
          render: (h, { index }) => h('span', index + 1)
        },
        {
          title: this.$t('class-attendance-report-for-admin.card_number'),
          slot: 'card_number',
          width: 150
        },
        {
          title: this.$t('class-attendance-report-for-admin.student_name'),
          slot: 'student_name',
          width: 150
        },
        {
          title: this.$t('class-attendance-report-for-admin.absent_status'),
          slot: 'absent_status',
          width: 150,
          align: 'center'
        },
        {
          title: this.$t('class-attendance-report-for-admin.gender'),
          slot: 'gender',
          width: 150
        },
        {
          title: this.$t('class-attendance-report-for-admin.father_name'),
          slot: 'father_name',
          width: 150
        },
        {
          title: this.$t('class-attendance-report-for-admin.father_phone'),
          slot: 'father_phone',
          width: 150,
          align: 'center'
        },
        {
          title: this.$t('class-attendance-report-for-admin.mother_name'),
          slot: 'mother_name',
          width: 150
        },
        {
          title: this.$t('class-attendance-report-for-admin.mother_phone'),
          slot: 'mother_phone',
          width: 150,
          align: 'center'
        },
        {
          title: this.$t('class-attendance-report-for-admin.comments'),
          key: 'comments',
          width: 250,
          align: 'center'
        },
        {
          title: this.$t('class-attendance-report-for-admin.modified_by'),
          key: 'modified_by',
          width: 250,
          align: 'center'
        },
        {
          title: this.$t('class-attendance-report-for-admin.modified_date'),
          key: 'modified_date',
          width: 250,
          align: 'center'
        }
      ]
    }
  },
  methods: {
    edit(record) {
      this.$store.commit('classAttendanceReport/SET_EDIT_DATA', record)
      this.visible = true
    },
    handleCancel() {
      this.visible = false
      this.$emit('cancel')
    }
  }
}
</script>
